var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeorgia = function SvgGeorgia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#georgia_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M16 9V7H9V0H7v7H0v2h7v7h2V9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M4 12h1v1H4v1H3v-1H2v-1h1v-1h1zm9 0h1v1h-1v1h-1v-1h-1v-1h1v-1h1zM4 2v1h1v1H4v1H3V4H2V3h1V2zm9 1h1v1h-1v1h-1V4h-1V3h1V2h1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "georgia_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff",
    rx: 4
  })))));
};
export { SvgGeorgia as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSIjRUVFIiBkPSJNMCAwaDE2djE2SDB6Ii8+PHBhdGggZmlsbD0iI0Q4MDAyNyIgZD0iTTE2IDlWN0g5VjBIN3Y3SDB2Mmg3djdoMlY5eiIvPjxwYXRoIGZpbGw9IiNEODAwMjciIGQ9Ik00IDEyaDF2MUg0djFIM3YtMUgydi0xaDF2LTFoMXptOSAwaDF2MWgtMXYxaC0xdi0xaC0xdi0xaDF2LTFoMXpNNCAydjFoMXYxSDR2MUgzVjRIMlYzaDFWMnptOSAxaDF2MWgtMXYxaC0xVjRoLTFWM2gxVjJoMXoiLz48L2c+PGRlZnM+PGNsaXBQYXRoIGlkPSJhIj48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiNmZmYiIHJ4PSI0Ii8+PC9jbGlwUGF0aD48L2RlZnM+PC9zdmc+";